const ROLE = {
    SECRETARY:'Secretary',
    ASSISTANT_SECRETARY:'Assistant Secretary',
    COMPANY_ADMIN:'Company Admin',
    ADMIN:'Admin',
    DIRECTOR:'Director'    
}


export { ROLE };
